import { DataUsage, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button, Collapse } from "@mui/material";
import { useState } from "react";
import { IClient } from "../../../../../Typings/Client";
import { ClientQuotaSection } from "./ClientQuotaSection";

export const MessagingQuotaButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Button
        data-test={"profile-menu-expand-quota-link"}
        onClick={() => setOpen(!open)}
        startIcon={<DataUsage fontSize="small" />}
      >
        Messaging Quotas
        {open ? <ExpandLess /> : <ExpandMore />}
      </Button>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ClientQuotaSection />
      </Collapse>
    </Box>
  );
};
